import BookForm from "components/shared/book/form";
import { FilesField } from "components/shared/form";
import { serializeReq } from "helpers/form";
import React from "react";
import { uploadFile } from "sources/books/news";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class FormNews extends BookForm {
    renderBody = () => {
        const { config } = this.props;
        return (
            <Markup
                {...config}
                renderField={this.renderField}
                renderFiles={this.renderFiles}
                editorValue={this.state.text}
                onChange={this.setValue}
            />
        );
    };

    renderFiles = () => (
        <FilesField
            withoutDownload
            modal={this.props.modal}
            files={this.state.files}
            uploadFile={uploadFile}
            onChange={(files) => this.setState({ files, fileIds: files.map((file) => file.id) })}
        />
    );

    onSubmit = (e) => {
        e.preventDefault();
        const { isLoading, isValid, ...state } = this.state;
        if (!isLoading) {
            if (this.isValidForm(state)) {
                this.setState({ isLoading: true, isValid: true });
                delete state.files;
                return this.applyReq(serializeReq(state));
            }
            this.setState({ isValid: false });
        }
    };
}

const ConfiguredForm = (props) => <FormNews {...props} config={config} initialState={initialState} />;

export default ConfiguredForm;
